import { __rest } from "tslib";
import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5ccaa088"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "Frame w-screen h-screen max-w-full max-h-full" };
import { reactive, computed, onBeforeMount } from "vue";
import { gsap } from "gsap";
import { round } from "@/utils/number.utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIPicture',
    props: {
        border: { default: "solid" },
        src: {},
        alt: {},
        width: {},
        height: {},
        loading: {},
        decoding: {}
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "befbc9bc": (aspectRatio.value),
            "d178741a": (clipPath.outer),
            "d2281864": (clipPath.inner)
        }));
        const { border } = __props, props = __rest(__props, ["border"]);
        const clipPath = reactive({ inner: "none", outer: "none" });
        const width = computed(() => typeof props.width === "string" ? parseInt(props.width) : props.width);
        const height = computed(() => typeof props.height === "string" ? parseInt(props.height) : props.height);
        const aspectRatio = computed(() => width.value && height.value ? width.value / height.value : "auto");
        function generateClipPath(points, offset) {
            const randPoints = gsap.utils.random(points[0], points[1], 1, true);
            const randOffset = gsap.utils.random(0, offset, 1, true);
            const sides = [
                { x: 0, y: 0, xInc: 1, yInc: 0 },
                { x: 100, y: 0, xInc: 0, yInc: 1 },
                { x: 0, y: 100, xInc: 1, yInc: 0 },
                { x: 0, y: 0, xInc: 0, yInc: 1 },
            ];
            const polygon = sides.map(({ x, y, xInc, yInc }, i) => {
                const backwards = i >= 2;
                const nbPoints = randPoints() + 1;
                const points = [];
                const segment = 100 / (nbPoints - 1);
                for (let j = backwards ? nbPoints - 1 : 0; backwards ? j > 0 : j < (nbPoints - 1); backwards ? j-- : j++) {
                    points.push(`calc(${randOffset() * (!!x || xInc && backwards ? -1 : 1)}px + ${round(x + xInc * j * segment, 3)}%) calc(${randOffset() * (!!y || yInc && backwards ? -1 : 1)}px + ${round(y + yInc * j * segment, 3)}%)`);
                }
                return points.join(", ");
            }).join(", ");
            return `polygon(${polygon})`;
        }
        function computeClipPaths() {
            clipPath.inner = generateClipPath([3, 5], 10);
            clipPath.outer = clipPath.inner;
            if (border === "paper") {
                clipPath.outer = generateClipPath([40, 60], 4);
            }
        }
        onBeforeMount(computeClipPaths);
        return (_ctx, _cache) => {
            const _component_UIImage = _resolveComponent("UIImage");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["UIPicture relative", `border-${border}`])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_UIImage, _normalizeProps(_guardReactiveProps(props)), null, 16),
                    _renderSlot(_ctx.$slots, "default")
                ])
            ], 2));
        };
    }
});
